import { render, staticRenderFns } from "./file-add.vue?vue&type=template&id=711b4b8d&scoped=true"
import script from "./file-add.vue?vue&type=script&lang=js"
export * from "./file-add.vue?vue&type=script&lang=js"
import style0 from "./file-add.vue?vue&type=style&index=0&id=711b4b8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711b4b8d",
  null
  
)

export default component.exports